export const IdFlag = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ borderRadius: '10px' }}
    >
      {/* Red stripe */}
      <rect
        width="20"
        height="10"
        fill="#E30B17"
      />
      {/* White stripe */}
      <rect
        y="10"
        width="20"
        height="10"
        fill="#FFFFFF"
      />
    </svg>
  );
};
